
export default {
  name: "elasticHeader",
  computed: {
    // #22057 — exact-match per-listing SEO doc for this path (or undefined)
    seo() {
      return (this.$store.getters.cms.listing_page_seo || []).find(
        (d) => d && d.match_url === this.$route.path
      );
    },
  },
  methods: {
    activeFilters() {
      let excludes = [
        "total",
        "page",
        "pages",
        "sort",
        "limit",
        "sorting",
        "orderby",
        "order",
        "business_activity",
        "family",
        "subfamily",
        "category",
        "business_activity_slug",
        "family_slug",
        "subfamily_slug",
        "category_slug",
        "manufacturer_slug"
      ];
      return Object.keys(this.$store.getters.filters).reduce((acc, _) => {
        // if(_ == 'tag.anagki' && this.$store.getters.filters[_].split('_or_').length == 1){
        //   return acc;
        // }
        if (!excludes.includes(_)) {
          if (this.$store.getters.filters[_].includes("_or_")) {
            let t = this.$store.getters.filters[_].split("_or_");
            (t || []).forEach((tt) => {
              if (tt) {
                acc.push({ key: _, value: tt });
              }
            });
          } else {
            acc.push({ key: _, value: this.$store.getters.filters[_] });
          }
        }
        return acc;
      }, []);
    },
    async selectFilter(value, key) {
      let inc = (((value || {}).value || "").split("+") || []).reduce(
        (acc, _) => {
          if (_) {
            let k = _.split("=")[0];
            let v = _.split("=")[1];
            acc[k] = v;
          }
          return acc;
        },
        {}
      );
      if (!inc.orderby && key != "limit") {
        return;
      }
      if (this.$store.getters.filters.orderby != inc.orderby) {
        this.$store.getters.filters.page = 1;
      } else {
      }
      this.$store.commit("filters", {
        ...this.$store.getters.filters,
        orderby: inc.orderby,
        order: inc.order,
        sorting: key != "limit" ? value : this.$store.getters.filters.sorting,
        limit: key == "limit" ? value : this.$store.getters.filters.limit,
      });
      let t = this.$hyperUtility.urlElasticCreator();
      if (process.browser) {
        location.href = t;
      } else {
        this.$router.push(t);
      }
    },
  },
};
